import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const ComputerEngineeringHeader = () => {
  return (
    <CourseHeader
      title="Computer"
      highlight="Engineering"
      subtitle="Design. Build. Innovate."
      backgroundImage="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=2072&q=80"
    />
  );
};

export default ComputerEngineeringHeader;
